import { StatusChip } from '../components/StatusChip';
import { MethodChip } from '../components/MethodChip';
import { colors } from '@src/styles';
import { Box, IconButton, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { ReactNode } from 'react';
import { format } from 'date-fns';
import { monoFontFamily } from '../scriptsStyles';

const monoCellSX = {
  fontFamily: monoFontFamily,
  fontSize: '12px',
  color: colors.brand.textSecondary,
  whiteSpace: 'nowrap',
} as const;

export const getRequestColumns = (requestActions: (id: string) => void) => {
  return [
    {
      label: 'Método',
      key: 'method',
      width: 90,
      sortable: true,
      align: 'left' as const,
      render: (row: object): ReactNode => <MethodChip method={'method' in row ? (row.method as string) : undefined} />,
    },
    {
      label: 'URL',
      key: 'url',
      sortable: true,
      align: 'left' as const,
      render: (row: object): ReactNode => {
        const url = 'url' in row ? (row.url as string) : '-';
        return (
          <Box
            title={url}
            sx={{
              fontFamily: monoFontFamily,
              fontSize: '12.5px',
              color: colors.brand.textStrong,
              maxWidth: 520,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {url}
          </Box>
        );
      },
    },
    {
      label: 'Criado',
      key: 'createdAt',
      width: 110,
      sortable: true,
      align: 'left' as const,
      render: (row: object) => (
        <Box sx={monoCellSX}>
          {'createdAt' in row && row.createdAt ? format(new Date(row.createdAt as string), 'dd/MM/yyyy') : '—'}
        </Box>
      ),
    },
    {
      label: 'Iniciado',
      key: 'startedAt',
      width: 140,
      sortable: true,
      align: 'left' as const,
      render: (row: object) => (
        <Box sx={monoCellSX}>
          {'startedAt' in row && row.startedAt ? format(new Date(row.startedAt as string), 'dd/MM HH:mm:ss') : '—'}
        </Box>
      ),
    },
    {
      label: 'Finalizado',
      key: 'finishedAt',
      width: 140,
      sortable: true,
      align: 'left' as const,
      render: (row: object) => (
        <Box sx={monoCellSX}>
          {'finishedAt' in row && row.finishedAt ? format(new Date(row.finishedAt as string), 'dd/MM HH:mm:ss') : '—'}
        </Box>
      ),
    },
    {
      label: 'Status',
      key: 'status',
      width: 130,
      sortable: true,
      align: 'left' as const,
      render: (row: object): ReactNode => <StatusChip status={'status' in row ? (row.status as string) : undefined} />,
    },
    {
      label: 'Layer',
      key: 'layer',
      width: 80,
      sortable: true,
      render: (row: object): ReactNode => <Box sx={monoCellSX}>{'layer' in row ? (row.layer as number) : '—'}</Box>,
    },
    {
      label: '',
      key: 'details',
      width: 56,
      sortable: false,
      align: 'right' as const,
      render: (row: object): ReactNode => (
        <Tooltip title="Ver detalhes" arrow>
          <IconButton
            aria-label="Ver detalhes da action"
            onClick={(event) => {
              event.stopPropagation();
              requestActions('id' in row ? (row.id as string) : '');
            }}
            sx={{
              width: 30,
              height: 30,
              borderRadius: '8px',
              color: colors.brand.textSecondary,
              '& svg': { color: 'inherit', fontSize: 17 },
              '&:hover': { color: colors.primary.yellow, backgroundColor: 'rgba(255, 160, 21, 0.1)' },
            }}
          >
            <VisibilityOutlinedIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];
};
